<template>
  <div class="modal fade vaccate-modal" id="vacate-unit-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">
            {{unit ? `${unit.unitNo} ${unit.category} ${unit.occupants} ${unit.phoneNumber} ${unit.property}` : ''}}
          </h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body steps-container">
          <div class="row the-step biz-info active">
            <div class="col-12 mb-3">
              <label for="">Reason for Vacating the stall</label>
              <select class="form-select" v-model="reason">
                <option selected="" value="">Select Options</option>
                <option v-for="(item, index) in vacateReasons" :key="`${index}`">
                  {{item.reason}}
                </option>
              </select>
            </div>

            <div class="col-12 mb-3">
              <label for="">Effective from</label>
              <input v-model="effectiveFrom" class="form-control" type="date" placeholder="Select date">
            </div>

            <div class="col-12 mb-3">
              <label for="">More Details</label>
              <textarea v-model="description" rows="3" class="form-control" placeholder="Start typing ..."></textarea>
            </div>
          </div>

          <div class="row the-step biz-additional-info d-none">
            <div class="col-12">
              <div class="alert alert-warning" role="alert">
                You are changing something that needs two OTPs, which I sent to the first and second approver.
                You need to get the OTPs from them and enter them in order.
              </div>
            </div>
            <div class="col-12 mb-3">
              <label for="">First Approver</label>
              <input v-model="otpMessage1" class="form-control" placeholder="Enter OTP">
              <p style="color: red">{{message1}}</p>
            </div>

            <div class="col-12 mb-3">
              <label for="">Second Approver</label>
              <input v-model="otpMessage2" class="form-control" placeholder="Enter OTP">
              <p style="color: red">{{message2}}</p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex modal-next-prev-container">
            <button type="button" class="btn btn-outline-secondary btn-prev waves-effect waves-light me-3">
              <i class="bx bx-left-arrow-alt font-size-16 align-middle me-2"></i> Previous
            </button>

            <button @click="sendVacateOTP()" type="button" class="btn btn-primary waves-effect waves-light btn-next">
              Next <i class="bx bx-right-arrow-alt font-size-16 align-middle me-2"></i>
            </button>

            <button data-dismiss="modal" @click="vacateUnit()" type="button"
                    class="btn btn-submit btn-success d-none ml-3 ms-3 waves-effect waves-light btn-next">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Finish
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, rent } from "@/api";

export default {
  name: "VacateUnitModal",
  props: {
    unit: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      reason: '',
      effectiveFrom: '',
      description: '',
      vacateReasons: [],
      otpMessage1: null,
      otpMessage2: null,
      otp1: 0,
      otp2: 0,
      message1: null,
      message2: null
    };
  },
  watch: {
    otpMessage1() {
      if (this.otpMessage1 && this.otpMessage1.length > 3) {
        if (this.otpMessage1 == this.otp1) {
          this.message1 = null;
        } else {
          this.message1 = "Invalid OTP";
        }
      } else {
        this.message1 = null;
      }
    },
    otpMessage2() {
      if (this.otpMessage2 && this.otpMessage2.length > 3) {
        if (this.otpMessage2 == this.otp2) {
          this.message2 = null;
        } else {
          this.message2 = "Invalid OTP";
        }
      } else {
        this.message2 = null;
      }
    }
  },
  mounted() {
    this.getVacateReasons();
    this.initializeStepNavigation();
  },
  methods: {
    show() {
      const modal = new bootstrap.Modal(document.getElementById('vacate-unit-modal'));
      modal.show();
    },

    hide() {
      const modal = bootstrap.Modal.getInstance(document.getElementById('vacate-unit-modal'));
      if (modal) {
        modal.hide();
      }
    },

    initializeStepNavigation() {
      // Initialize step navigation for the modal
      const btnNext = this.$el.querySelector('.btn-next');
      const btnPrev = this.$el.querySelector('.btn-prev');
      const btnSubmit = this.$el.querySelector('.btn-submit');
      const steps = this.$el.querySelectorAll('.the-step');

      if (btnNext) {
        btnNext.addEventListener('click', () => {
          const activeStep = this.$el.querySelector('.the-step.active');
          const nextStep = activeStep?.nextElementSibling;

          if (nextStep && nextStep.classList.contains('the-step')) {
            activeStep.classList.remove('active');
            activeStep.classList.add('d-none');
            nextStep.classList.remove('d-none');
            nextStep.classList.add('active');

            // Show/hide buttons
            if (!nextStep.nextElementSibling || !nextStep.nextElementSibling.classList.contains('the-step')) {
              btnNext.classList.add('d-none');
              btnSubmit.classList.remove('d-none');
            }
            btnPrev.classList.remove('d-none');
          }
        });
      }

      if (btnPrev) {
        btnPrev.addEventListener('click', () => {
          const activeStep = this.$el.querySelector('.the-step.active');
          const prevStep = activeStep?.previousElementSibling;

          if (prevStep && prevStep.classList.contains('the-step')) {
            activeStep.classList.remove('active');
            activeStep.classList.add('d-none');
            prevStep.classList.remove('d-none');
            prevStep.classList.add('active');

            // Show/hide buttons
            btnNext.classList.remove('d-none');
            btnSubmit.classList.add('d-none');

            if (!prevStep.previousElementSibling || !prevStep.previousElementSibling.classList.contains('the-step')) {
              btnPrev.classList.add('d-none');
            }
          }
        });
      }
    },

    getVacateReasons() {
      const data = new FormData();
      data.append("function", "getVacateReasons");
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.vacateReasons = res.data.data.vacateReasons;
            }
          })
          .catch((e) => {
            console.error(e);
          });
    },

    sendVacateOTP() {
      this.otp1 = Math.floor(1000 + Math.random() * 9000);
      this.otp2 = Math.floor(1000 + Math.random() * 9000);

      const data = new FormData();
      data.append("function", "sendVacateOTP");
      data.append("description", `${this.unit.unitNo} ${this.unit.category} ${this.unit.occupants} ${this.unit.phoneNumber} ${this.unit.property}`);
      data.append("otp1", this.otp1);
      data.append("otp2", this.otp2);

      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              // Move to next step
              const btnNext = this.$el.querySelector('.btn-next');
              if (btnNext) {
                btnNext.click();
              }
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    vacateUnit() {
      if (this.otpMessage1 == this.otp1 && this.otpMessage2 == this.otp2) {
        const data = new FormData();
        data.append("function", "vacateUnit");
        data.append("effectiveFrom", this.effectiveFrom);
        data.append("id", this.unit.id);

        execute(data, rent)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.$emit('unit-vacated');
                this.hide();
                this.resetForm();
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert(e.message);
            });
      } else {
        alert("One or more invalid OTP");
      }
    },

    resetForm() {
      this.reason = '';
      this.effectiveFrom = '';
      this.description = '';
      this.otpMessage1 = null;
      this.otpMessage2 = null;
      this.otp1 = 0;
      this.otp2 = 0;
      this.message1 = null;
      this.message2 = null;
    }
  }
};
</script>